import { SearchOrderDocumentResult } from '@my-account/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MyAccountState, StateWithMyAccount } from '../my-account-state';
import { getMyAccountState } from './state.selectors';

const getOrderDocumentState: MemoizedSelector<StateWithMyAccount, MyAccountState['orderDocument']> = createSelector(
  getMyAccountState,
  (state: MyAccountState) => state.orderDocument,
);

export const getSearchOrderDocumentState: MemoizedSelector<
  StateWithMyAccount,
  StateUtils.LoaderState<SearchOrderDocumentResult>
> = createSelector(getOrderDocumentState, (state) => state.search);

export const getSearchOrderDocumentLoading: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getSearchOrderDocumentState,
  (state) => StateUtils.loaderLoadingSelector(state),
);

export const getSearchOrderDocumentSuccess: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getSearchOrderDocumentState,
  (state) => StateUtils.loaderSuccessSelector(state),
);

export const getSearchOrderDocumentError: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getSearchOrderDocumentState,
  (state) => StateUtils.loaderErrorSelector(state),
);

export const getSearchOrderDocumentValue: MemoizedSelector<StateWithMyAccount, SearchOrderDocumentResult> =
  createSelector(getSearchOrderDocumentState, (state) => StateUtils.loaderValueSelector(state));
